import CalendarIcon from '@mui/icons-material/CalendarMonth';
import CategoryIcon from '@mui/icons-material/Category';
import { ReactNode } from 'react';

export interface MenuOption {
  name: string;
  path: string;
  Icon: ReactNode;
  disabled?: boolean;
}

export const allReferenceMenuOptions: MenuOption[] = [
  { name: 'Products', path: '/reference/products', Icon: <CategoryIcon sx={{ fontSize: 15 }} /> },
  { name: 'Calendar', path: '/reference/calendar', Icon: <CalendarIcon sx={{ fontSize: 15 }} /> },
];
